var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import ButtonComponent from "./ButtonComponent";
/**
 *
 * This is a basic button component.
 * @export
 *
 * @example
 * ```
 *  <Button
 *      title="Click"
 *      onClick={() => {alert("Clicked")}}
 *  />
 * ```
 *
 * @example
 * ```
 *  <Button
 *      title="Click"
 *      onClick={() => {alert("Clicked")}}
 *      leftIcon="https://static.iviva.com/images/lucy-logo.svg"
 *      loading={isLoading}
 *      loadingTitle="Loading..."
 *      className="custom-css-class"
 * />
 * ```
 *
 */
const Button = (props) => {
    const { icon, iconPosition = 'left', iconStyles } = props, rest = __rest(props, ["icon", "iconPosition", "iconStyles"]);
    let leftIconStyles, rightIconStyles = {};
    if ((iconStyles === null || iconStyles === void 0 ? void 0 : iconStyles.hasOwnProperty('leftIcon')) || (iconStyles === null || iconStyles === void 0 ? void 0 : iconStyles.hasOwnProperty('rightIcon'))) {
        leftIconStyles = (iconStyles === null || iconStyles === void 0 ? void 0 : iconStyles.leftIcon) || {};
        rightIconStyles = (iconStyles === null || iconStyles === void 0 ? void 0 : iconStyles.rightIcon) || {};
    }
    else {
        leftIconStyles = (iconStyles || {});
        rightIconStyles = (iconStyles || {});
    }
    return _jsx(ButtonComponent, Object.assign({ leftIcon: iconPosition == 'left' ? icon : null, rightIcon: iconPosition == 'right' ? icon : null, leftIconStyles: leftIconStyles, rightIconStyles: rightIconStyles }, rest));
};
export default Button;
